import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import IndexSection from '@/pages/home/components/IndexSection';
import UpdateSection from '@/pages/home/components/UpdateSection';
import TopicSection from '@/pages/home/components/TopicSection';
import CommentSection from '@/pages/home/components/CommentSection';
import AppSection from '@/pages/home/components/AppSection';
import CardSection from '@/pages/home/components/CardSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FeatureSection from '@/pages/home/components/FeatureSection';
import MediaSection from '@/pages/home/components/MediaSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import RankingSection from '@/pages/home/components/RankingSection';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <IndexSection />
        <UpdateSection />
        <TopicSection />
        <CommentSection />
        <AppSection />
        <CardSection />
        <FaqSection />
        <AboutSection />
        <FeatureSection />
        <MediaSection />
        <ContactSection />
        <CarouselSection />
        <RankingSection />
      </main>
      <Footer />
    </>
  );
}